// CareLogix™ ORACLE — Agent Swarm Gen-3 API client (Phase 32A)
import axios from "axios";

const BASE = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");
const SWARM_BASE = `${BASE}/api/oracle/swarm`;
const ADMIN_BASE = `${BASE}/api/adminone/swarm`;

const MEMBER_TOKEN_KEYS = [
  "carelogix_member_token",
  "oracle.auth.token",
  "oracle.session_token",
];
const ADMIN_TOKEN_KEYS = [
  "carelogix_adminone_token",
  "oracle.adminone.token",
  "adminone.token",
  "adminone_jwt",
];

function readToken(keys) {
  if (typeof window === "undefined") return null;
  for (const k of keys) {
    try {
      const v = window.localStorage.getItem(k);
      if (v) return v;
    } catch (_) { /* ignore */ }
  }
  return null;
}

const publicHttp = axios.create({ baseURL: SWARM_BASE, timeout: 120_000 });
publicHttp.interceptors.request.use((cfg) => {
  const t = readToken(MEMBER_TOKEN_KEYS);
  if (t && cfg && cfg.headers) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

const adminHttp = axios.create({ baseURL: ADMIN_BASE, timeout: 60_000 });
adminHttp.interceptors.request.use((cfg) => {
  const t = readToken(ADMIN_TOKEN_KEYS);
  if (t && cfg && cfg.headers) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const swarmApi = {
  agents:  () => publicHttp.get("/agents"),
  query:   (payload) => publicHttp.post("/query", payload || {}),
  traces:  (limit) => publicHttp.get("/traces", { params: limit ? { limit } : undefined }),
};

export const adminSwarmApi = {
  queue:   (params) => adminHttp.get("/queue", { params: params || {} }),
  resolve: (traceId, action) =>
    adminHttp.post(`/queue/${encodeURIComponent(traceId)}`, null,
      { params: { action: action || "approve" } }),
  traces:  (limit) => adminHttp.get("/traces", { params: limit ? { limit } : undefined }),
};

export default { swarmApi, adminSwarmApi };
